import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from "./pages/EditPage.tsx";
import {useVerifiedPermissions} from "../../hooks/useVerifiedPermissions.ts";
import {AddPage as PhaseAddPage} from "../phases/pages/AddPage.tsx";
import {EditPage as PhaseEditPage} from "../phases/pages/EditPage.tsx";
import {AddPage as StepAddPage} from "../steps/pages/AddPage.tsx";
import {EditPage as StepEditPage} from "../steps/pages/EditPage.tsx";


export const PlaybooksLayout = () => {

    const {allowedActions} = useVerifiedPermissions()


    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes('ListPlaybooks') ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
            <Route
                path='add'
                element={
                    allowedActions.includes('CreatePlaybook') ? (
                        <AddPage/>
                    ) : (
                        <Navigate to='/playbooks'/>
                    )
                }
            />
            <Route
                path=':id'
                element={
                    allowedActions.includes('GetPlaybook') ? (
                        <EditPage/>
                    ) : (
                        <Navigate to='/playbooks'/>
                    )
                }
            />
            {/*
              Phase nested routes. :id is the playbookId; :phaseId is the phase's id.
              Phases live under /playbooks/:id/phases/... — they have no top-level route.
            */}
            <Route
                path=':id/phases/add'
                element={
                    allowedActions.includes('CreatePhase') ? (
                        <PhaseAddPage/>
                    ) : (
                        <Navigate to='/playbooks'/>
                    )
                }
            />
            <Route
                path=':id/phases/:phaseId'
                element={
                    allowedActions.includes('GetPhase') ? (
                        <PhaseEditPage/>
                    ) : (
                        <Navigate to='/playbooks'/>
                    )
                }
            />
            {/*
              Step nested routes (FNP-85). :id is the playbookId; :phaseId is
              the phase's id; :stepId is the step's id. Steps live under
              /playbooks/:id/phases/:phaseId/steps/... — no top-level route.
            */}
            <Route
                path=':id/phases/:phaseId/steps/add'
                element={
                    allowedActions.includes('CreateStep') ? (
                        <StepAddPage/>
                    ) : (
                        <Navigate to='/playbooks'/>
                    )
                }
            />
            <Route
                path=':id/phases/:phaseId/steps/:stepId'
                element={
                    allowedActions.includes('GetStep') ? (
                        <StepEditPage/>
                    ) : (
                        <Navigate to='/playbooks'/>
                    )
                }
            />
        </Routes>
    );
};
